import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "table-pager" }
const _hoisted_2 = { class: "table-pager__info" }
const _hoisted_3 = { class: "table-pager__size" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "table-pager__count" }
const _hoisted_7 = {
  key: 0,
  "aria-label": "Pagination"
}
const _hoisted_8 = { class: "pagination mb-0" }
const _hoisted_9 = { class: "page-item" }
const _hoisted_10 = {
  key: 0,
  class: "page-link table-pager__gap"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "page-item table-pager__mobile" }
const _hoisted_13 = { class: "page-link" }
const _hoisted_14 = { class: "page-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("span", null, "Voir", -1)),
        _createElementVNode("select", {
          class: "form-select form-select-sm",
          value: _ctx.perPage,
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPerPage && _ctx.onPerPage(...args)))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (n) => {
            return (_openBlock(), _createElementBlock("option", {
              key: n,
              value: n
            }, _toDisplayString(n), 9, _hoisted_5))
          }), 128))
        ], 40, _hoisted_4)
      ]),
      _createElementVNode("span", _hoisted_6, [
        (_ctx.pagination.total)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("b", null, _toDisplayString(_ctx.pagination.from) + "–" + _toDisplayString(_ctx.pagination.to), 1),
              _cache[4] || (_cache[4] = _createTextVNode(" sur ", -1)),
              _createElementVNode("b", null, _toDisplayString(_ctx.pagination.total), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("0 résultat")
            ], 64))
      ])
    ]),
    (_ctx.pagination.last_page > 1)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_7, [
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("li", _hoisted_9, [
              _createElementVNode("a", {
                class: _normalizeClass(["page-link", { disabled: _ctx.pagination.current_page <= 1 }]),
                href: "#",
                "aria-label": "Précédent",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.go(_ctx.pagination.current_page - 1)), ["prevent"]))
              }, _cache[5] || (_cache[5] = [
                _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
              ]), 2)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: i,
                class: _normalizeClass(["page-item table-pager__page", { 'table-pager__page--current': item === _ctx.pagination.current_page }])
              }, [
                (item === '…')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "…"))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: _normalizeClass(["page-link", { active: item === _ctx.pagination.current_page }]),
                      href: "#",
                      onClick: _withModifiers(($event: any) => (_ctx.go(item)), ["prevent"])
                    }, _toDisplayString(item), 11, _hoisted_11))
              ], 2))
            }), 128)),
            _createElementVNode("li", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.pagination.current_page) + " / " + _toDisplayString(_ctx.pagination.last_page), 1)
            ]),
            _createElementVNode("li", _hoisted_14, [
              _createElementVNode("a", {
                class: _normalizeClass(["page-link", { disabled: _ctx.pagination.current_page >= _ctx.pagination.last_page }]),
                href: "#",
                "aria-label": "Suivant",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.go(_ctx.pagination.current_page + 1)), ["prevent"]))
              }, _cache[6] || (_cache[6] = [
                _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
              ]), 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}